import { UserApi } from './user.api';
import { StructureApi } from './structure.api';
import { AssociationApi } from './association.api';
import { StructureDto, StructuresRequest } from '../model/structure.dto';
import { AssociationDto, AssociationsRequest } from '../model/association.dto';

export class ApiService {
  private userApi: UserApi;
  private structureApi: StructureApi;
  private assoicationApi: AssociationApi;

  constructor() {
    this.userApi = new UserApi();
    this.structureApi = new StructureApi();
    this.assoicationApi = new AssociationApi();
  }

  // 유저
  public async login(id: string, pw: string) {
    return await this.userApi.login({ email: id, password: pw });
  }

  public async getUserName(accessToken: string) {
    return await this.userApi.getUserName(accessToken);
  }

  public async getNewToken(refreshToken: string) {
    return await this.userApi.getNewToken(refreshToken);
  }

  // 인증서
  public async getCertificationList(accessToken: string, facilityNumber: string, applicant: string, sido: string, sigungu: string, location: string, phoneNumber: string, offset?:number, limit?:number) {
    return await this.structureApi.certificationList(accessToken, facilityNumber, applicant, sido, sigungu, location, phoneNumber, offset, limit);
  }

  public async postCertification(accessToken: string, dto: StructureDto | null) {
    return await this.structureApi.certificationAdd(accessToken, dto);
  }

  public async postCertifications(accessToken: string, list: StructuresRequest | null) {
    return await this.structureApi.certificationsAdd(accessToken, list);
  }

  public async putCertification(accessToken: string, dto: StructureDto) {
    return await this.structureApi.putCertification(accessToken, dto);
  }

  public async delCertification(accessToken: string, checkItems: number[]) {
    return await this.structureApi.delCertification(accessToken, checkItems);
  }

  public async duplicateHits(accessToken: string, facilityNumber: string) {
    return await this.structureApi.duplicateHits(accessToken, facilityNumber);
  }

  public async searchCertificationList(accessToken: string, facilityNumber: string, applicant: string, sido: string, sigungu: string, location: string, phoneNumber: string) {
    return await this.structureApi.certificationSearch(accessToken, facilityNumber, applicant, sido, sigungu, location, phoneNumber);
  }

  // 회원증
  public async associationList(accessToken: string, name: string, userNumber: string, phoneNumber: string, belong:string, memberLevel:string, offset?:number, limit?:number) {
    return await this.assoicationApi.associationList(accessToken, name, userNumber, phoneNumber, belong, memberLevel, offset, limit);
  }

  public async associationAdd(accessToken: string, dto: AssociationDto | null) {
    return await this.assoicationApi.associationAdd(accessToken, dto);
  }

  public async associationsAdd(accessToken: string, dto: AssociationsRequest | null) {
    return await this.assoicationApi.associationsAdd(accessToken, dto);
  }

  public async putAssociation(accessToken: string, dto: AssociationDto) {
    return await this.assoicationApi.putAssociation(accessToken, dto);
  }

  public async delAssociation(accessToken: string, checkItems: number[]) {
    return await this.assoicationApi.delAssociation(accessToken, checkItems);
  }

  public async duplicateHitsNumber(accessToken: string, userNumber: string) {
    return await this.assoicationApi.duplicateHits(accessToken, userNumber);
  }

  public async associationSearch(accessToken: string, name: string, userNumber: string, phoneNumber: string, belong:string, memberLevel:string, offset?:number, limit?:number) {
    return await this.assoicationApi.associationSearch(accessToken, name, userNumber, phoneNumber, belong, memberLevel, offset, limit);
  }
}